import { ANALYTIC_CMS } from '../../../constants/analytics.constant';
import { CommonUtility } from '../../../utils/commonUtils';
import { HeaderComponent } from './header.component';
import { IObject } from '../../../models/interfaces/IObject';
import { ROUTER_CONSTANTS } from '../../../constants/router.constants';

export const NAVIGATION_HEADER = 'NavigationHeader';
export const GLOBAL = 'global';

export const headerConstants = {
  upsLogo: '/assets/images/upsLogo.svg',
  upsLogo_altText: 'UPS Logo',
};

export const HeaderOptionsConfig: (ref: HeaderComponent) => any = (ref) => {
  return {
    [`${ROUTER_CONSTANTS.dashboard}`]: {
      analyticsCMS: ANALYTIC_CMS.dashboard,
      showBackBtn: CommonUtility.isNavigatingFromSymphony(),
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      selectedDashboard: 'Case Management',
      customText: CommonUtility.isSymphonyAccount()
        ? ref.contentPipe.transform('db_casemgmt_heading')
        : null,
    },
    [`${ROUTER_CONSTANTS.gffCRM}`]: {
      analyticsCMS: ANALYTIC_CMS.gffCRM,
      showBackBtn: CommonUtility.isNavigatingFromSymphony(),
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      selectedDashboard: 'GFF CRM',
      customText: CommonUtility.isSymphonyAccount()
        ? ref.contentPipe.transform('lbl_title_digital_collaboration')
        : null,
    },
    [`${ROUTER_CONSTANTS.detail}`]: {
      analyticsCMS: ANALYTIC_CMS.detail,
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return (
          ref.contentPipe.transform('dt_case_heading') +
          ' ' +
          decodeURIComponent(queryParams?.caseNumber)
        );
      },
    },
    [`${ROUTER_CONSTANTS.viewAccount}`]: {
      analyticsCMS: ANALYTIC_CMS.viewAccount,
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return queryParams?.accountName ? queryParams?.accountName : '';
      },
    },
    [`${ROUTER_CONSTANTS.viewAccountHierarchy}`]: {
      analyticsCMS: ANALYTIC_CMS.viewAccountHierarchy,
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return queryParams?.accountName ? queryParams?.accountName : '';
      },
    },
    [`${ROUTER_CONSTANTS.ccpAccount}`]: {
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return queryParams?.accountName ? queryParams?.accountName : '';
      },
    },
    [`${ROUTER_CONSTANTS.contacts}`]: {
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return queryParams?.accountName ? queryParams?.accountName : '';
      },
    },
    [`${ROUTER_CONSTANTS.productDetail}`]: {
      analyticsCMS: ANALYTIC_CMS.productDetail,
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customTextCallBack(id: string, queryParams: IObject): string {
        return queryParams?.accountName ? queryParams?.accountName : '';
      },
    },
    [`${ROUTER_CONSTANTS.createCase}`]: {
      analyticsCMS: ANALYTIC_CMS.create,
      showBackBtn: true,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
      customText: ref.contentPipe.transform('lbl_create_case_heading'),
    },
    [`${ROUTER_CONSTANTS.cxProfile}`]: {
      showBackBtn: true,
      customText: null,
      gffCRM: ref.contentPipe.transform('db_gff_crm_heading'),
    },
  };
};
